/**
 * Lazy loading images
 */
const lazyImages = document.querySelectorAll("img.lazy");
if ("IntersectionObserver" in window) {
    const lazyImageObserver = new IntersectionObserver((entries) => {
        entries.forEach( (entry) => {
            if (entry.isIntersecting) {
                let lazyImage = <HTMLImageElement>entry.target;
                lazyImage.src = lazyImage.dataset.src;
                if (lazyImage.dataset.srcset) {
                    lazyImage.srcset = lazyImage.dataset.srcset;
                }
                lazyImage.classList.remove("lazy");
                lazyImageObserver.unobserve(lazyImage);
            }
        });
    });

    lazyImages.forEach((lazyImage) => {
        lazyImageObserver.observe(lazyImage);
    });
}

/**
 * Lazy-load background images
 */
const lazyBackgrounds = document.querySelectorAll(".lazy-background");
if ("IntersectionObserver" in window) {
    const lazyBackgroundObserver = new IntersectionObserver((entries) => {
        entries.forEach( (entry) => {
            if (entry.isIntersecting) {
                let lazyTarget = <HTMLElement>entry.target;
                lazyTarget.classList.add('visible');
                lazyTarget.classList.remove('lazy-background');
                lazyBackgroundObserver.unobserve(lazyTarget);
            }
        });
    });

    lazyBackgrounds.forEach((lazyTarget) => {
        lazyBackgroundObserver.observe(lazyTarget);
    });
}

/**
 * Preload images with the .lazy-preload class
 */
const lazyPreloadImages = document.querySelectorAll('[data-lazy-preload]');
if ("IntersectionObserver" in window) {
    const lazyPreloadImageObserver = new IntersectionObserver((entries) => {
        entries.forEach( (entry) => {
            if (entry.isIntersecting) {
                let lazyPreload = entry.target.querySelectorAll('[data-lazy-preload-image]');
                lazyPreload.forEach( (elem: HTMLElement) => {
                    let image = new Image();
                    image.src = elem.dataset.lazyPreloadImage;
                });
                lazyPreloadImageObserver.unobserve(entry.target);
            }
        });
    });

    lazyPreloadImages.forEach((lazyPreload) => {
        lazyPreloadImageObserver.observe(lazyPreload);
    });
}

/**
 * Lazy load iframes
 */
const lazyFrames = document.querySelectorAll(".lazy-iframe");
if ("IntersectionObserver" in window) {
    const lazyFrameObserver = new IntersectionObserver( (entries) => {
        entries.forEach( (entry) => {
            if (entry.isIntersecting) {
                let lazyFrame = <HTMLIFrameElement>entry.target;
                lazyFrame.src = lazyFrame.dataset.src;
                lazyFrame.classList.remove("lazy-iframe");
                lazyFrameObserver.unobserve(lazyFrame);
            }
        });
    });

    lazyFrames.forEach((lazyFrame) => {
        lazyFrameObserver.observe(lazyFrame);
    });
}